import request from '@/utils/request'

// 查询远程教育公益培训-培训资料列表
export function listPxzl(query) {
  return request({
    url: '/web/zlts/pxzl/list',
    method: 'get',
    params: query
  })
}

// 查询远程教育公益培训-培训资料详细
export function getPxzl(recid) {
  return request({
    url: '/web/zlts/pxzl/' + recid,
    method: 'get'
  })
}

// 新增远程教育公益培训-培训资料
export function addPxzl(data) {
  return request({
    url: '/web/zlts/pxzl',
    method: 'post',
    data: data
  })
}

// 修改远程教育公益培训-培训资料
export function updatePxzl(data) {
  return request({
    url: '/web/zlts/pxzl/edit',

    method: 'post',
    data: data
  })
}

// 删除远程教育公益培训-培训资料
export function delPxzl(recid) {
  return request({
    url: '/web/zlts/pxzl/remove/' + recid,

    method: 'post',
  })
}

// 导出远程教育公益培训-培训资料
export function exportPxzl(query) {
  return request({
    url: '/web/zlts/pxzl/export',
    method: 'get',
    params: query
  })
}